import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ANIMATIONS, APPLICATION_STATUS, CERTIFICATE_STAGE_TYPES, CODE_TYPES, FIRM_APPLICATION_TYPES, FIRM_SERVICES, FIRM_SERVICE_FOR, LEAD_BASED_PAINT} from '@shared/utils/app-static-data';
import { IUser } from 'app/auth/auth.models';
import { IFirm } from 'app/models/firms/firm';
import { IFirmCertificate } from 'app/models/firms/firmCertificate';
import { IFirmApplication } from 'app/models/firms/firm-application';
import { IFirmApplicationPerson } from 'app/models/firms/firm-application-person';
import { CommonDataService } from 'app/services/common/common-data.service';
import { DocumentService } from 'app/services/document/document.service';
import { SharedService } from 'app/services/core/shared.service';
import { FirmService } from 'app/services/firm/firm-service';
import { UntypedFormGroup, UntypedFormControl, Validators, AbstractControl, ValidatorFn, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UserInformationService } from 'app/services/user-info/user-info.service';
import { AddFirmApplicationPersonComponent } from './add-firm-application-person/add-firm-application-person.component';
import { IFirmAddress } from 'app/models/firms/firmAddress';
import { IAddress } from 'app/models/common/address';
import { PaymentService } from 'app/components/payments/services/payments.service';
import { IPayment } from 'app/components/payments/models/payment';
import { IFirmApplicationDeficiency } from 'app/models/firms/firm-application-deficiency';
import { AddFirmApplicationDeficiencyComponent } from './add-firm-application-deficiency/add-firm-application-deficiency.component';
import { IContactInformation } from 'app/models/common/contactInformation';
import { IFirmContactInformation } from 'app/models/firms/firmContactInformation';
import { IFirmPerson } from 'app/models/firms/firmPerson';
import { IPerson } from 'app/models/People/person';
import { IPersonContactInformation } from 'app/models/People/personContactInformation';
import { IAccountAffiliation } from 'app/models/common/accountAffiliation';
import { PersonService } from 'app/services/person/person.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatStepper } from '@angular/material/stepper';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { ConfirmationDialogueComponent } from '../../common/confirmation-dialogue/confirmation-dialogue.component';
import { AtpApplicationApprovalDialogComponent, AtpApplicationApprovalDialogResult } from 'app/components/application/atp/add-atp-application/atp-application-approval-dialog/atp-application-approval-dialog.component';
import { IFirmLeadCredential } from 'app/models/firms/firmLeadCredentials';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ConfirmationDialogueWithFieldComponent } from '../../common/confirmation-dialogue-with-field/confirmation-dialogue-with-field.component';
import { AddDocumentComponent } from 'app/components/common/document/add-document.component';
import { SelectListDialogueComponent } from '../../common/select-list-dialogue/select-list-dialogue.component';
import { FirmAddEditComponent } from 'app/components/firm/add-edit/firm-add-edit.component';
import { ILinkApprovalEmailStatus } from 'app/models/common/account-link-approval';

@Component({
  selector: 'app-add-firm-application',
  templateUrl: './add-firm-application.component.html',
  styleUrls: ['./add-firm-application.component.scss'],
  animations: ANIMATIONS
})
export class AddFirmApplicationComponent implements OnInit {
  public isMobile: boolean = false;
  public step: number = 0;
  public allowApplicationChooser: boolean = false;
  public showApplicationChooser: boolean = false;
  public linkValidationSummaryRequested: boolean = false;
  public applicationDataForm = null;
  public applicationAttestationForm = null
  public linkFirmIdDisplayControl: FormControl = new FormControl('');
  public filteredLinkUsers: IUser[] = [];
  public linkUserDisplayControl: FormControl = new FormControl('');
  public filteredLinkFirms: IFirm[] = [];
  public cardColor: string = this.sharedService.gold + '20';
  public firmServices = FIRM_SERVICES;    
  public applicationStatus = APPLICATION_STATUS;
  public isApplicationForExistingFirm: boolean = false;
  public issueDate: string = '';
  public firmSearchInput$ = new Subject<string>();
  public linkFirmSearchInput$ = new Subject<string>();
  public linkUserSearchInput$ = new Subject<string>();
  public certificateNumber: string = '';
  public sendingLinkApprovalEmails: boolean = false;
  public loadingLinkApprovalEmailStatus: boolean = false;
  public linkApprovalEmailStatus: ILinkApprovalEmailStatus | null = null;

  public firmApplication: IFirmApplication;    
  public loading: boolean = true;
  public reload: boolean = false;
  public canEdit: boolean = true;
  public uiData: any = LEAD_BASED_PAINT;
  public pageSize: number = 50;      
  public applicationPersons: IFirmApplicationPerson[] = [];   
  public userID: string = '';

  public applicationDeficiencies: IFirmApplicationDeficiency[] = [];
  public filteredApplicationDeficiencies:IFirmApplicationDeficiency[] = [];
  public applicationDeficiencyStatusFilterString: FormControl = new FormControl('both');
  public applicationDeficiencyFilterString: string = '';
  private readonly applicationDeficiencyDebounceString: Subject<string> = new Subject<string>();
  public deficiencyPageSize: number = 5;
  public displayedDeficiencyColumns: string[] = ['id', 'description', 'isResolved'];
  public displayedDeficiencyColumnsFormat = [
    {displayName:'Id',columnName:'id', type:'number', size:'10'},
    {displayName:'Description',columnName:'description', type:'string', size:'70'},
    {displayName:'Resolved',columnName:'isResolved', type:'boolean', size:'10'},
  ];
  public deficiencyDataSource: MatTableDataSource<any>;
  @ViewChild('deficiencyTablePaginator') deficiencyPaginator: MatPaginator;
  @ViewChild('deficiencyTableSort') deficiencySort: MatSort;
  
  public individualTable:{icon:string,title:string,layout:any};
  public firmApplicationPerson: IFirmPerson[] = [];
  public filteredApplicationPerson: {}[] = [];  
  public applicationPersonFilterString: string = '';
  private readonly applicationPersonDebounceString: Subject<string> = new Subject<string>();
  public personPageSize: number = 5;  
  public personDataSource: MatTableDataSource<any>;
  public changeIndicator: number = 0;
  @ViewChild('personTablePaginator') personPaginator: MatPaginator;
  @ViewChild('personTableSort') personSort: MatSort;

  public tableApplicationDocumentsColumns = ['id', 'fileName', 'fileDescription', 'actions']
  public tableApplicationDocumentsFormat = [        
    {displayName:'Id',columnName:'id', type:'number', size:'10'}, 
    {displayName:'File Name',columnName:'fileName', type:'string', size:'30'},
    {displayName:'File Description',columnName:'fileDescription', type:'string', size:'40'},
  ];
  public tableApplicationDocumentsData = []
  public tableApplicationDocumentsFilteredData = []
  public tableApplicationDocumentsPageSize = 5;
  public filterDocumentString: string = '';  
  public documentDataSource: MatTableDataSource<any>;
  @ViewChild('DocumentTablePaginator') documentPaginator: MatPaginator;
  @ViewChild('DocumentTableSort') documentSort: MatSort;
  @ViewChild('firmLinkStepper') firmLinkStepper: MatStepper;
  @ViewChild('linkDeficiencyCard') linkDeficiencyCard?: ElementRef<HTMLTextAreaElement>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      application: IFirmApplication, 
      edit: boolean, 
      firmData: {
        firm: IFirm, 
        mailingAddress: IAddress, 
        physicalAddress: IAddress, 
        contactInformation: IContactInformation, 
        firmCurrentCertificates: IFirmCertificate[],
        firmCertificateForRenewal: IFirmCertificate,    
        renewal: boolean,     
        firmCurrentCredentials: IFirmLeadCredential[],
        firmContactPerson: IPerson,
        firmContactPersonContactInformation: IContactInformation,
      }
    },
    private readonly dialogRef: MatDialogRef<AddFirmApplicationComponent>,
    public sharedService: SharedService,
    public firmService: FirmService,
    private readonly personService: PersonService,
    public userService: UserInformationService,
    public commonService: CommonDataService,
    public documentService: DocumentService,
    private readonly toastr: ToastrService,
    private readonly dialog: MatDialog,
    public paymentService: PaymentService,
    private readonly breakpointObserver: BreakpointObserver,
  ) {     
    this.breakpointObserver.observe([
      Breakpoints.Handset,
      Breakpoints.Tablet,
      Breakpoints.Small,
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });

    this.firmSearchInput$
    .pipe(
      debounceTime(500),          // Wait 300ms after the user stops typing
      distinctUntilChanged(),     // Only emit if the input has changed
      tap((searchTerm) => {        
        return this.performFirmSearch(searchTerm);
      })
    ).subscribe();

    this.linkFirmSearchInput$
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((searchTerm) => this.searchLinkFirms(searchTerm));

    this.linkUserSearchInput$
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((searchTerm) => this.searchLinkUsers(searchTerm));

    this.allowApplicationChooser = !this.data?.application
      && !this.data?.firmData?.firm
      && !this.data?.firmData?.renewal
      && !this.data?.firmData?.firmCertificateForRenewal;

    this.isApplicationForExistingFirm = this.data?.firmData?.firm !== undefined || (this.data?.application?.firm !== undefined && this.data?.application?.firm !== null);
    this.initializeDebounceFunctions();
  }

  ngOnInit(): void {
    this.setApplicationDataFormFields();
    this.configureApplicationDataForm();
    this.loadData();
  }

  get isLinkApplication(): boolean {
    return this.isLinkApplicationType(this.firmApplication?.applicationType ?? this.data?.application?.applicationType);
  }

  get dialogTitle(): string {
    if (this.showApplicationChooser) {
      return 'Firm Application';
    }

    if ((this.firmApplication?.id ?? 0) === 0) {
      return this.isLinkApplication ? 'New Firm Link Request' : 'New Firm Application';
    }

    return this.firmApplication.id + ': ' + this.firmApplication.firmName + ' - ' + this.firmApplication.applicationType.toUpperCase();
  }

  get canReturnToChooser(): boolean {
    return this.allowApplicationChooser
      && !this.showApplicationChooser
      && (this.firmApplication?.id ?? 0) === 0;
  }

  get canApproveApplication(): boolean {
    return this.applicationAttestationForm?.valid === true
      && this.applicationDataForm?.valid === true
      && (this.firmApplication?.id ?? 0) !== 0
      && (!this.isLinkApplication || (!!this.getLinkedFirm()?.id && !!this.firmApplication?.userID));
  }

  isApplicationApproved(): boolean {
    return this.firmApplication?.status === APPLICATION_STATUS.approved;
  }

  initializeDebounceFunctions(): void {
    this.applicationDeficiencyDebounceString.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(value => {
      this.applicationDeficiencyFilterString = value.trim().toLowerCase();
      this.filterDeficiencyTable();     
    });

    this.applicationPersonDebounceString.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(value => {      
      this.applicationPersonFilterString = value.trim().toLowerCase();      
      this.filterPersonTable();     
    });
  }

  firmSearch(event: any){  
    const inputElement = event.target as HTMLInputElement;
    this.firmSearchInput$.next(inputElement.value);
  }

  performFirmSearch(value: string){        
    const searchValue = (value ?? '').trim();
    const linkedFirmName = (this.getLinkedFirm()?.name ?? '').trim().toLowerCase();

    if(searchValue.length > 2 && (!this.getLinkedFirm() || searchValue.toLowerCase() !== linkedFirmName)){
      this.firmService.searchFirm(value).subscribe(res=>{
        if(res.length > 0){
          const dialogRef = this.dialog.open(SelectListDialogueComponent, {
            width: '80%',
            data: {
                    items: res, 
                    message: 'Select an Existing Firm to Link this Application to, click Cancel if this is a New Firm', 
                    title: 'Select/Link an Existing Firm',
                    type: 'firm'
                  },
            autoFocus: false,});
          dialogRef.afterClosed().subscribe(result => {
            if(result){
              this.applyLinkedFirmSelection(result);
            }      
          });
        }
      },err=>{this.toastr.error("There was an error searching for firms: ", err)});
    }
  }

  onLinkUserInput(event: any): void {
    const searchValue = event.target.value || '';
    this.firmApplication.userID = searchValue.trim();
    this.linkUserSearchInput$.next(searchValue);
  }

  onLinkFirmInput(event: any): void {
    const searchValue = event.target.value || '';
    this.linkFirmIdDisplayControl.setValue('', { emitEvent: false });
    this.firmApplication.firm = null;
    this.data.application.firm = null;
    this.data.firmData.firm = null;
    this.updateExistingFirmState();
    this.configureApplicationDataForm();
    this.linkFirmSearchInput$.next(searchValue);
  }

  onLinkFirmIdInput(event: any): void {
    const searchValue = event.target.value || '';
    this.applicationDataForm.controls['firmName'].setValue('', { emitEvent: false });
    this.firmApplication.firm = null;
    this.data.application.firm = null;
    this.data.firmData.firm = null;
    this.updateExistingFirmState();
    this.configureApplicationDataForm();
    this.linkFirmSearchInput$.next(searchValue);
  }

  getLinkUserDisplay(user: Partial<IUser> | null, fallbackEmail: string = ''): string {
    if (!user) {
      return fallbackEmail || '';
    }

    const fullName = (user.fullName || '').trim();
    const email = (user.email || fallbackEmail || '').trim();

    if (fullName && email) {
      return `${fullName} (${email})`;
    }

    return fullName || email;
  }

  getLinkFirmDisplayName(firm: IFirm): string {
    if (!firm) {
      return '';
    }

    const firmId = firm.id ? `${firm.id}: ` : '';
    return `${firmId}${firm.name || ''}`.trim();
  }

  selectLinkUser(user: IUser): void {
    this.firmApplication.userID = user.email || '';
    this.linkUserDisplayControl.setValue(this.getLinkUserDisplay(user), { emitEvent: false });
    this.filteredLinkUsers = [];
  }

  selectLinkFirm(firm: IFirm): void {
    this.applyLinkedFirmSelection(firm);
    this.filteredLinkFirms = [];
  }

  private applyLinkedFirmSelection(result: IFirm): void {
    this.linkFirmIdDisplayControl.setValue(result.id?.toString() || '', { emitEvent: false });
    this.applicationDataForm.controls['firmName'].setValue(result.name);
    this.applicationDataForm.controls['ccb'].setValue(result.ccb);
    this.applicationDataForm.controls['firmServices'].setValue(result.servicesAvailable);
    this.applicationDataForm.controls['isPublic'].setValue(result.isPrivate);

    this.firmService.getFirmLeadCredentials(result.id).subscribe(res=>{
      res.forEach(credential => {
        let strippedString = credential.firmLeadCredentialType.replace(/\s+/g, '');
        let modifiedString = strippedString.charAt(0).toLowerCase() + strippedString.slice(1);
        this.applicationDataForm.controls[modifiedString].setValue(true);
      });
    },err=>{this.toastr.error("An error occurred getting the Firm Credentials: ", err)});

    this.applicationDataForm.controls['firmPhysicalStreet'].setValue('Linked');
    this.applicationDataForm.controls['firmPhysicalState'].setValue('Linked');
    this.applicationDataForm.controls['firmPhysicalCity'].setValue('Linked');
    this.applicationDataForm.controls['firmPhysicalZip'].setValue('11111');
    this.applicationDataForm.controls['firmPhysicalCounty'].setValue('Linked');
    this.applicationDataForm.controls['firmMailingStreet'].setValue('Linked');
    this.applicationDataForm.controls['firmMailingState'].setValue('Linked');
    this.applicationDataForm.controls['firmMailingCity'].setValue('Linked');
    this.applicationDataForm.controls['firmMailingZip'].setValue('11111');
    this.applicationDataForm.controls['firmMailingCounty'].setValue('Linked');
    this.applicationDataForm.controls['firmPhone'].setValue('111-111-1111');
    this.applicationDataForm.controls['firmEmail'].setValue('linked@linked');
    this.applicationDataForm.controls['firmConfirmEmail'].setValue('linked@linked');
    this.applicationDataForm.controls['contactTitle'].setValue('Linked');
    this.applicationDataForm.controls['contactFirstName'].setValue('Linked');
    this.applicationDataForm.controls['contactLastName'].setValue('Linked');
    this.applicationDataForm.controls['contactPhone'].setValue('111-111-1111');
    this.applicationDataForm.controls['contactEmail'].setValue('linked@linked');
    this.applicationDataForm.controls['contactConfirmEmail'].setValue('linked@linked');

    this.firmApplication.firm = result;
    this.data.application.firm = result;
    this.data.firmData.firm = result;
    this.updateExistingFirmState();
    this.configureApplicationDataForm();
    this.refreshLinkApprovalEmailStatus();
  }

  private searchLinkUsers(searchValue: string): void {
    const normalizedSearchValue = searchValue?.trim() || '';
    if (normalizedSearchValue.length < 2) {
      this.filteredLinkUsers = [];
      return;
    }

    this.commonService.searchB2CUsers(normalizedSearchValue).subscribe({
      next: (users) => {
        this.filteredLinkUsers = users || [];
      },
      error: () => {
        this.filteredLinkUsers = [];
      }
    });
  }

  private searchLinkFirms(searchValue: string): void {
    const normalizedSearchValue = searchValue?.trim() || '';
    if (normalizedSearchValue.length < 2) {
      this.filteredLinkFirms = [];
      return;
    }

    this.firmService.searchFirm(normalizedSearchValue).subscribe({
      next: (firms) => {
        this.filteredLinkFirms = firms || [];
      },
      error: () => {
        this.filteredLinkFirms = [];
      }
    });
  }

  private hydrateLinkUserDisplay(email: string | null | undefined): void {
    const normalizedEmail = (email || '').trim();
    if (!normalizedEmail) {
      this.linkUserDisplayControl.setValue('', { emitEvent: false });
      return;
    }

    this.commonService.searchB2CUsers(normalizedEmail).subscribe({
      next: (users) => {
        const matchingUser = (users || []).find(user => (user.email || '').toLowerCase() === normalizedEmail.toLowerCase());
        this.linkUserDisplayControl.setValue(this.getLinkUserDisplay(matchingUser || null, normalizedEmail), { emitEvent: false });
      },
      error: () => {
        this.linkUserDisplayControl.setValue(normalizedEmail, { emitEvent: false });
      }
    });
  }

  removeFirm(){
    this.firmApplication.firm = null
    this.data.firmData.firm = null;
    this.data.application.firm = null;
    this.firmApplication.renewal = false;
    this.updateExistingFirmState();
    this.configureApplicationDataForm();
    this.refreshLinkApprovalEmailStatus();
  }

  loadData(){
    this.loading = true;

    this.userService.getUserInfo().subscribe(
    res=>{
      this.userID = res.email;          
    })
    
    if(this.data.application !== null){
      this.firmService.getFirmApplicationById(this.data.application.id).subscribe(
        res=>{        
          this.firmApplication = res;
          this.data.application = res;
          this.hydrateLinkUserDisplay(this.firmApplication.userID);
          this.linkFirmIdDisplayControl.setValue(this.firmApplication?.firm?.id?.toString() || '', { emitEvent: false });
          this.updateExistingFirmState();
          this.configureApplicationDataForm();
          this.canEdit = (this.firmApplication.status !== APPLICATION_STATUS.approved) && (this.data.edit)            
          this.updateIndividualTable();
          this.refreshTableApplicationDocuments();
          this.loadFormFields();

          this.updateFirmApplicationDeficiencies();
          this.refreshLinkApprovalEmailStatus();
          this.loading=false;
        },
        err=>{this.toastr.error("There was an error getting the firm applicatoin: ", err)})
      
        this.firmService.getFirmApplicationPeople(this.data.application.id).subscribe(res=>{          
          this.firmApplicationPerson = res;          
          this.filterPersonTable();          
        },err=>{this.toastr.error("An error occurred getting the Firm Application People: ", err)});

        if(this.data.application.firm !== null && this.data.firmData.firm === undefined){
          this.data.firmData.firm = this.data.application.firm;

          this.firmService.getFirmLeadCredentials(this.data.application.firm.id).subscribe(res=>{
            this.data.firmData.firmCurrentCredentials = res;                    
          },err=>{this.toastr.error("An error occurred getting the Firm Credentials: ", err)});

          this.firmService.getFirmAddresses(this.data.application.firm.id).subscribe(res=>{
            this.data.firmData.physicalAddress = res.filter(x=>x.isCurrentPhysical)[0].address;
            this.data.firmData.mailingAddress = res.filter(x=>x.isCurrentMailing)[0].address;
          },err=>{this.toastr.error("An error occurred getting the Firm Addresses: ", err)});

          this.firmService.getFirmContactInformations(this.data.application.firm.id).subscribe(res=>{
            this.data.firmData.contactInformation = res[0]?.contactInformation;
          },err=>{this.toastr.error("An error occurred getting the Firm Contact Information: ", err)});

          if(this.data.application.renewal){
            this.firmService.getFirmCertificates(this.data.application.firm.id).subscribe(res=>{
              this.data.firmData.firmCertificateForRenewal = res.filter(x=>x.controlNumber === this.data.application.previousApplication)[0];
            },err=>{this.toastr.error("An error occurred getting the Firm Certificate: ", err)});
          }

          this.firmService.getFirmPeople(this.data.application.firm.id).subscribe(res=>{
            let person = res.filter(staff=>staff.isPOC)[0].person;
            this.data.firmData.firmContactPerson = person
            this.personService.getPersonContactInformationByPersonId(person.id).subscribe(res=>{
              this.data.firmData.firmContactPersonContactInformation = res?.contactInformation;
            },err=>{this.toastr.error("An error occurred getting the Firm Contact Person Contact Information: ", err)});
          },err=>{this.toastr.error("An error occurred getting the Firm People: ", err)});          
        }
    }
    else{
      this.firmApplication = this.allowApplicationChooser
        ? this.createStandaloneDraftApplication(false)
        : this.createContextualDraftApplication();

      this.updateExistingFirmState();
      this.configureApplicationDataForm();
      this.updateIndividualTable();
      this.loadFormFields();
      
      this.data.application = this.firmApplication;      
      this.showApplicationChooser = this.allowApplicationChooser;
      this.hydrateLinkUserDisplay(this.firmApplication.userID);
      this.linkFirmIdDisplayControl.setValue(this.firmApplication?.firm?.id?.toString() || '', { emitEvent: false });
      this.refreshLinkApprovalEmailStatus();
      this.loading = false;      
    }
  }

  get displayedDeficiencyColumnNames() {
    return this.displayedDeficiencyColumnsFormat.map(column => column.columnName);
  }
  
  getStatusTypeValues() {        
    let typeValues = (this.firmApplication.status === APPLICATION_STATUS.approved) ? Object.values(APPLICATION_STATUS) : Object.values(APPLICATION_STATUS).filter(x=>x!==APPLICATION_STATUS.approved);
    return typeValues;
  }

  getFirmServiceForTypeValues() {    
    return Object.values(FIRM_SERVICE_FOR);
  }

  changeStep(step: StepperSelectionEvent): void {
    if (this.isLinkApplication && this.step === 0 && step.selectedIndex > 0) {
      const firmNameValue = (this.applicationDataForm.get('firmName')?.value ?? '').toString().trim();
      if (firmNameValue.length > 2) {
        this.performFirmSearch(firmNameValue);
      }
    }

    this.step = step.selectedIndex;
  }

  goToNextStep(): void {
    if (this.firmLinkStepper && this.showLinkNextButton()) {
      this.firmLinkStepper.next();
    }
  }

  goToPreviousStep(): void {
    if (this.showLinkPreviousButton()) {
      this.step--;
      return;
    }

    if (this.canReturnToChooser) {
      this.showApplicationChooser = true;
      this.linkValidationSummaryRequested = false;
      this.step = 0;
    }
  }

  showLinkPreviousButton(): boolean {
    return this.step > 0;
  }

  showLinkNextButton(): boolean {
    return this.step < 2;
  }

  selectNewApplication(): void {
    this.firmApplication = this.createStandaloneDraftApplication(false);
    this.data.application = this.firmApplication;
    this.data.firmData.firm = null;
    this.showApplicationChooser = false;
    this.linkValidationSummaryRequested = false;
    this.step = 0;
    this.linkUserDisplayControl.setValue('', { emitEvent: false });
    this.linkFirmIdDisplayControl.setValue('', { emitEvent: false });
    this.filteredLinkUsers = [];
    this.filteredLinkFirms = [];
    this.updateExistingFirmState();
    this.configureApplicationDataForm();
    this.updateIndividualTable();
    this.loadFormFields();
    this.refreshLinkApprovalEmailStatus();
  }

  selectLinkApplication(): void {
    this.firmApplication = this.createStandaloneDraftApplication(true);
    this.data.application = this.firmApplication;
    this.data.firmData.firm = null;
    this.showApplicationChooser = false;
    this.linkValidationSummaryRequested = false;
    this.step = 0;
    this.linkUserDisplayControl.setValue('', { emitEvent: false });
    this.linkFirmIdDisplayControl.setValue('', { emitEvent: false });
    this.filteredLinkUsers = [];
    this.filteredLinkFirms = [];
    this.updateExistingFirmState();
    this.configureApplicationDataForm();
    this.updateIndividualTable();
    this.loadFormFields();
    this.refreshLinkApprovalEmailStatus();
  }

  hasLinkValidationErrors(): boolean {
    return this.linkValidationSummaryRequested && this.getLinkValidationErrors().length > 0;
  }

  hasLinkFeedbackContent(): boolean {
    return this.isLinkApplication || this.getUnresolvedLinkDeficiencyDescriptions().length > 0 || this.hasLinkValidationErrors();
  }

  getLinkCombinedFeedback(): string {
    const detailLines = [
      `• User ID - ${this.formatLinkFeedbackValue(this.firmApplication?.userID, 'Not available')}`,
      `• Firm ID - ${this.formatLinkFeedbackValue(this.getLinkedFirm()?.id, 'Not linked')}`,
      `• Firm Name - ${this.formatLinkFeedbackValue(this.getLinkedFirm()?.name || this.applicationDataForm?.get('firmName')?.value, 'Not linked')}`,
      `• Attestation - ${this.applicationAttestationForm?.get('attestation')?.value === true ? 'Yes' : 'No'}`,
      `• ESignature - ${this.formatLinkFeedbackValue(this.applicationAttestationForm?.get('esignature')?.value)}`,
    ];

    let combined = '--- Link Request Details ---\n' + detailLines.join('\n');

    const deficiencyDescriptions = this.getUnresolvedLinkDeficiencyDescriptions();
    if (deficiencyDescriptions.length > 0) {
      combined += '\n\n' + deficiencyDescriptions.join('\n\n');
    }

    const errors = this.getLinkValidationErrors();
    if (this.linkValidationSummaryRequested && errors.length > 0) {
      if (combined) {
        combined += '\n\n';
      }

      combined += '--- Missing Required Fields ---\n';
        const stepOrder = ['Admin'];
      const errorsByStep = new Map<string, string[]>();

      errors.forEach(error => {
        const existing = errorsByStep.get(error.step) ?? [];
        existing.push(error.label);
        errorsByStep.set(error.step, existing);
      });

      stepOrder.forEach(stepName => {
        if (errorsByStep.has(stepName)) {
          combined += `• ${stepName} - ${errorsByStep.get(stepName)!.join(', ')}\n`;
        }
      });
    }

    return combined;
  }

  private formatLinkFeedbackValue(value: any, emptyValue: string = 'Not Provided'): string {
    const normalized = (value ?? '').toString().trim();
    return normalized.length > 0 ? normalized : emptyValue;
  }

  openLinkedFirm(): void {
    const linkedFirm = this.getLinkedFirm();
    if (!linkedFirm?.id) {
      return;
    }

    this.firmService.getFirm(linkedFirm.id).subscribe({
      next: (result) => {
        const dialogRef = this.dialog.open(FirmAddEditComponent, {
          width: '90%',
          autoFocus: false,
          data: result,
        });

        dialogRef.afterClosed().subscribe(() => {
          this.firmService.getFirm(linkedFirm.id).subscribe({
            next: (updatedFirm) => {
              this.firmApplication.firm = updatedFirm;
              this.data.application.firm = updatedFirm;
              this.applicationDataForm.patchValue({
                firmName: updatedFirm?.name || this.applicationDataForm.get('firmName')?.value,
                ccb: updatedFirm?.ccb || this.applicationDataForm.get('ccb')?.value,
              });
              this.refreshLinkApprovalEmailStatus();
            },
            error: () => undefined,
          });
        });
      },
      error: (error) => {
        this.toastr.error('Error loading Firm', error);
      }
    });
  }

  private isLinkApplicationType(applicationType: string | null | undefined): boolean {
    return (applicationType ?? '').toString().trim().toLowerCase() === FIRM_APPLICATION_TYPES.link;
  }

  getLinkedFirm(): IFirm | null {
    return this.firmApplication?.firm ?? this.data?.application?.firm ?? this.data?.firmData?.firm ?? null;
  }

  private getDefaultLinkApprovalEmailStatus(disabledReason: string): ILinkApprovalEmailStatus {
    return {
      requestType: 'Firm',
      applicationId: this.firmApplication?.id ?? 0,
      hasSelectedEntity: !!this.getLinkedFirm()?.id,
      hasValidContactEmails: false,
      validContactEmails: [],
      lastApprovalEmailSentAt: null,
      disabledReason,
    };
  }

  private refreshLinkApprovalEmailStatus(): void {
    if (!this.isLinkApplication) {
      this.linkApprovalEmailStatus = null;
      this.loadingLinkApprovalEmailStatus = false;
      return;
    }

    if (!(this.firmApplication?.id > 0)) {
      this.linkApprovalEmailStatus = this.getDefaultLinkApprovalEmailStatus('Save the link request before sending approval emails.');
      return;
    }

    this.loadingLinkApprovalEmailStatus = true;
    this.firmService.getFirmLinkApprovalEmailStatus(this.firmApplication).subscribe(status => {
      this.loadingLinkApprovalEmailStatus = false;
      this.linkApprovalEmailStatus = status ?? this.getDefaultLinkApprovalEmailStatus('Unable to evaluate approval email status.');
    }, () => {
      this.loadingLinkApprovalEmailStatus = false;
      this.linkApprovalEmailStatus = this.getDefaultLinkApprovalEmailStatus('Unable to evaluate approval email status.');
    });
  }

  canSendLinkApprovalEmails(): boolean {
    if (!this.isLinkApplication || this.isApplicationApproved() || this.sendingLinkApprovalEmails || this.loadingLinkApprovalEmailStatus) {
      return false;
    }

    if (!(this.firmApplication?.id > 0) || !this.getLinkedFirm()?.id) {
      return false;
    }

    const applicationUserId = (this.firmApplication?.userID || '').trim();
    if (!applicationUserId) {
      return false;
    }

    return this.linkApprovalEmailStatus?.hasValidContactEmails === true;
  }

  getSendLinkApprovalDisabledReason(): string {
    if (!this.isLinkApplication) {
      return '';
    }

    if (this.isApplicationApproved()) {
      return 'Approved link requests cannot send new approval emails.';
    }

    if (this.sendingLinkApprovalEmails) {
      return 'Approval emails are currently being sent.';
    }

    if (this.loadingLinkApprovalEmailStatus) {
      return 'Checking link approval email status...';
    }

    if (!(this.firmApplication?.id > 0)) {
      return 'Save the link request before sending approval emails.';
    }

    if (!this.getLinkedFirm()?.id) {
      return 'Select a matching Firm before sending approval emails.';
    }

    const applicationUserId = (this.firmApplication?.userID || '').trim();
    if (!applicationUserId) {
      return 'Assign a User ID email before sending approval emails.';
    }

    return this.linkApprovalEmailStatus?.disabledReason || 'No valid contact email is available for the selected Firm.';
  }

  getLinkApprovalEmailRecipientsSummary(): string {
    if (!this.isLinkApplication) {
      return '';
    }

    if (this.loadingLinkApprovalEmailStatus) {
      return 'Checking contact emails...';
    }

    const contactEmails = this.linkApprovalEmailStatus?.validContactEmails || [];
    if (contactEmails.length === 0) {
      return this.getSendLinkApprovalDisabledReason();
    }

    return `${contactEmails.length} valid contact email${contactEmails.length === 1 ? '' : 's'}: ${contactEmails.join(', ')}`;
  }

  sendLinkApprovalEmails(): void {
    if (!this.canSendLinkApprovalEmails()) {
      this.toastr.error(this.getSendLinkApprovalDisabledReason());
      return;
    }

    this.updateFirmApplicationData();
    this.sendingLinkApprovalEmails = true;
    this.firmService.sendFirmLinkApprovalEmails(this.firmApplication).subscribe(result => {
      this.sendingLinkApprovalEmails = false;

      if (result?.emailsSent > 0) {
        const label = result.emailsSent === 1 ? 'email' : 'emails';
        this.toastr.success(`Approval ${label} sent to ${result.emailsSent} contact recipient(s).`);
      } else {
        this.toastr.success('Approval emails queued.');
      }

      this.refreshLinkApprovalEmailStatus();
    }, error => {
      this.sendingLinkApprovalEmails = false;
      this.toastr.error('There was an error sending approval emails for this link request: ', error);
    });
  }

  private updateExistingFirmState(): void {
    this.isApplicationForExistingFirm = this.getLinkedFirm() !== null;
  }

  private requiresManualFirmDetails(): boolean {
    return !this.isLinkApplication && !this.isApplicationForExistingFirm;
  }

  private getUnresolvedLinkDeficiencyDescriptions(): string[] {
    return (this.applicationDeficiencies || [])
      .filter(deficiency => deficiency.isResolved !== true)
      .map(deficiency => deficiency.description)
      .filter(description => !!description);
  }

  private getLinkValidationErrors(): Array<{ field: string; label: string; step: string }> {
    const errors: Array<{ field: string; label: string; step: string }> = [];
    const firmName = (this.applicationDataForm?.get('firmName')?.value ?? '').toString().trim();
    const userId = (this.firmApplication?.userID ?? '').toString().trim();
    const esignature = (this.applicationAttestationForm?.get('esignature')?.value ?? '').toString().trim();

    if (!userId) {
      errors.push({ field: 'userID', label: 'User ID', step: 'Admin' });
    }

    if (!firmName) {
      errors.push({ field: 'firmName', label: 'Firm Name', step: 'Admin' });
    }

    if (!this.getLinkedFirm()?.id) {
      errors.push({ field: 'linkedFirm', label: 'Firm ID', step: 'Admin' });
    }

    if (this.applicationAttestationForm?.get('attestation')?.value !== true) {
      errors.push({ field: 'attestation', label: 'Attestation', step: 'Admin' });
    }

    if (!esignature) {
      errors.push({ field: 'esignature', label: 'Electronic Signature', step: 'Admin' });
    }

    return errors;
  }

  private getFirstLinkErrorStepIndex(errors: Array<{ field: string; label: string; step: string }>): number {
    return 0;
  }

  private scrollLinkDeficiencyCardIntoView(): void {
    setTimeout(() => {
      this.linkDeficiencyCard?.nativeElement?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 0);
  }

  private createStandaloneDraftApplication(isLinkApplication: boolean): IFirmApplication {
    const date = new Date();

    return {
      id: 0,
      userID: null,
      firm: null,
      status: APPLICATION_STATUS.inReview,
      applicationDate: date.toISOString(),
      applicationType: isLinkApplication ? FIRM_APPLICATION_TYPES.link : FIRM_APPLICATION_TYPES.rrp,
      approverEmail: null,
      approvalDate: null,
      applicationViableDate: null,
      firmName: '',
      ccb: '',
      coverage: '',
      renewal: false,
      previousApplication: '',
      isPublic: false,
      inspections: false,
      clearanceTesting: false,
      leadHazardScreening: false,
      riskAssessments: false,
      abatement: false,
      mailingIsPhysical: false,
      contactTitle: '',
      contactFirstName: '',
      contactMiddleName: '',
      contactLastName: '',
      contactPhone: '',
      contactAlternatePhone: '',
      contactFaxPhone: '',
      contactEmail: '',
      contactConfirmEmail: '',
      firmPhysicalStreet: '',
      firmPhysicalState: '',
      firmPhysicalCity: '',
      firmPhysicalZip: '',
      firmPhysicalCounty: '',
      firmMailingStreet: '',
      firmMailingState: '',
      firmMailingCity: '',
      firmMailingZip: '',
      firmMailingCounty: '',
      firmPhone: '',
      firmAlternatePhone: '',
      firmFaxPhone: '',
      firmEmail: '',
      firmConfirmEmail: '',
      firmWebsite: '',
      firmServices: FIRM_SERVICE_FOR.unk,
      attestation: false,
      esignature: '',
    };
  }

  private createContextualDraftApplication(): IFirmApplication {
    const date = new Date();

    return {
      id: 0,

      userID: null,
      firm: this.data.firmData?.firm ?? null,
      status: APPLICATION_STATUS.inReview,
      applicationDate: date.toISOString(),
      applicationType: this.data?.firmData?.firmCertificateForRenewal?.codeType==='LBP Firm' ? FIRM_APPLICATION_TYPES.lbpa : FIRM_APPLICATION_TYPES.rrp,
      approverEmail: null,
      approvalDate: null,
      applicationViableDate: this.data?.firmData?.firmCertificateForRenewal?.expirationDate ? new Date(new Date(this.data.firmData.firmCertificateForRenewal.expirationDate).setDate(new Date(this.data.firmData.firmCertificateForRenewal.expirationDate).getDate() + 1)).toISOString() : null,

      firmName: this.data?.firmData?.firm?.name ?? '',
      ccb: this.data?.firmData?.firm?.ccb ?? '',
      coverage: this.data?.firmData?.firm?.coverage ?? '',
      renewal: this.data?.firmData?.renewal ?? false,
      previousApplication: this.data?.firmData?.firmCertificateForRenewal?.controlNumber ?? '',
      isPublic: this.data?.firmData?.firm?.isPrivate ?? false,
      inspections: this.data?.firmData?.firmCurrentCredentials?.some(x=>x.firmLeadCredentialType === FIRM_SERVICES.inspections) ?? false,
      clearanceTesting: this.data?.firmData?.firmCurrentCredentials?.some(x=>x.firmLeadCredentialType === FIRM_SERVICES.clearanceTesting) ?? false,
      leadHazardScreening: this.data?.firmData?.firmCurrentCredentials?.some(x=>x.firmLeadCredentialType === FIRM_SERVICES.leadHazardScreening) ?? false,
      riskAssessments: this.data?.firmData?.firmCurrentCredentials?.some(x=>x.firmLeadCredentialType === FIRM_SERVICES.riskAssessments) ?? false,
      abatement: this.data?.firmData?.firmCurrentCredentials?.some(x=>x.firmLeadCredentialType === FIRM_SERVICES.abatement) ?? false,
      mailingIsPhysical: false,
      contactTitle: this.data?.firmData?.firmContactPerson?.title ?? '',
      contactFirstName: this.data?.firmData?.firmContactPerson?.firstName ?? '',
      contactMiddleName: this.data?.firmData?.firmContactPerson?.middleName ?? '',
      contactLastName: this.data?.firmData?.firmContactPerson?.lastName ?? '',
      contactPhone: this.data?.firmData?.firmContactPersonContactInformation?.phone ?? '',
      contactAlternatePhone: this.data?.firmData?.firmContactPersonContactInformation?.cell ??'',
      contactFaxPhone: this.data?.firmData?.firmContactPersonContactInformation?.fax ?? '',
      contactEmail: this.data?.firmData?.firmContactPersonContactInformation?.email ?? '',
      contactConfirmEmail: this.data?.firmData?.firmContactPersonContactInformation?.email ?? '',

      firmPhysicalStreet: this.data?.firmData?.physicalAddress?.street ?? '',
      firmPhysicalState: this.data?.firmData?.physicalAddress?.state ??'',
      firmPhysicalCity: this.data?.firmData?.physicalAddress?.city ?? '',
      firmPhysicalZip: this.data?.firmData?.physicalAddress?.zip ?? '',
      firmPhysicalCounty: this.data?.firmData?.physicalAddress?.county ??'',
      firmMailingStreet: this.data?.firmData?.mailingAddress?.street ?? '' ,
      firmMailingState: this.data?.firmData?.mailingAddress?.state ?? '',
      firmMailingCity: this.data?.firmData?.mailingAddress?.city ??'',
      firmMailingZip: this.data?.firmData?.mailingAddress?.zip ??'',
      firmMailingCounty: this.data?.firmData?.mailingAddress?.county ?? '',
      firmPhone: this.data?.firmData?.contactInformation?.phone ?? '',
      firmAlternatePhone: this.data?.firmData?.contactInformation?.cell ?? '',
      firmFaxPhone: this.data?.firmData?.contactInformation?.fax ?? '',
      firmEmail: this.data?.firmData?.contactInformation?.email ??'',
      firmConfirmEmail: this.data?.firmData?.contactInformation?.email ??'',
      firmWebsite: this.data?.firmData?.contactInformation?.website ?? '',
      firmServices: this.data?.firmData?.firm?.servicesAvailable ?? FIRM_SERVICE_FOR.unk,

      attestation: false,
      esignature: '',
    };
  }

  private configureApplicationDataForm(): void {
    if (!this.applicationDataForm) {
      return;
    }

    const requiresManualFirmDetails = this.requiresManualFirmDetails();
    const phonePatternValidator = Validators.pattern(/^\(?([0-9]{3})\)?[-\s]*([0-9]{3})-?([0-9]{4}).*$/);
    const zipPatternValidator = Validators.pattern(/^\d{5}(-\d{4})?$/);

    this.setControlValidators('applicationDate', this.isLinkApplication ? [] : [Validators.required]);
    this.setControlValidators('applicationViableDate', this.isLinkApplication ? [] : [Validators.required]);
    this.setControlValidators('contactFirstName', requiresManualFirmDetails ? [Validators.required] : []);
    this.setControlValidators('contactLastName', requiresManualFirmDetails ? [Validators.required] : []);
    this.setControlValidators('contactPhone', requiresManualFirmDetails ? [Validators.required, phonePatternValidator] : []);
    this.setControlValidators('contactAlternatePhone', requiresManualFirmDetails ? [phonePatternValidator] : []);
    this.setControlValidators('contactFaxPhone', requiresManualFirmDetails ? [phonePatternValidator] : []);
    this.setControlValidators('contactEmail', requiresManualFirmDetails ? [Validators.required, Validators.email] : []);
    this.setControlValidators('contactConfirmEmail', requiresManualFirmDetails ? [Validators.required, Validators.email] : []);
    this.setControlValidators('firmPhysicalState', requiresManualFirmDetails ? [Validators.required] : []);
    this.setControlValidators('firmPhysicalStreet', requiresManualFirmDetails ? [Validators.required] : []);
    this.setControlValidators('firmPhysicalCity', requiresManualFirmDetails ? [Validators.required] : []);
    this.setControlValidators('firmPhysicalZip', requiresManualFirmDetails ? [Validators.required, zipPatternValidator] : []);
    this.setControlValidators('firmMailingStreet', requiresManualFirmDetails ? [Validators.required] : []);
    this.setControlValidators('firmMailingCity', requiresManualFirmDetails ? [Validators.required] : []);
    this.setControlValidators('firmMailingState', requiresManualFirmDetails ? [Validators.required] : []);
    this.setControlValidators('firmMailingZip', requiresManualFirmDetails ? [Validators.required, zipPatternValidator] : []);
    this.setControlValidators('firmPhone', requiresManualFirmDetails ? [Validators.required, phonePatternValidator] : []);
    this.setControlValidators('firmAlternatePhone', requiresManualFirmDetails ? [phonePatternValidator] : []);
    this.setControlValidators('firmFaxPhone', requiresManualFirmDetails ? [phonePatternValidator] : []);
    this.setControlValidators('firmEmail', requiresManualFirmDetails ? [Validators.required, Validators.email] : []);
    this.setControlValidators('firmConfirmEmail', requiresManualFirmDetails ? [Validators.required, Validators.email] : []);

    this.applicationDataForm.updateValueAndValidity({ emitEvent: false });
  }

  private setControlValidators(controlName: string, validators: ValidatorFn[]): void {
    const control = this.applicationDataForm.get(controlName);
    if (!control) {
      return;
    }

    control.setValidators(validators);
    control.updateValueAndValidity({ emitEvent: false });
  }

  editDeficiency(deficiencyToEdit: IFirmApplicationDeficiency){
    let dialogRef = this.dialog.open(AddFirmApplicationDeficiencyComponent, {
      width: this.isMobile ? '90%' : '40%',
      data: {deficiency: deficiencyToEdit, firmApplication: this.firmApplication},});
    dialogRef.afterClosed().subscribe(result => {
      if (result){
        this.updateFirmApplicationDeficiencies();
      }        
    });
  }

  toggleDeficiencyResolved(deficiencyToEdit: IFirmApplicationDeficiency, isChecked: boolean){
    deficiencyToEdit.isResolved = isChecked;
    this.firmService.saveFirmApplicationDeficiency(deficiencyToEdit).subscribe(result=>{},error=>{console.error("There was an error saving the deficiency:", error)});
  }

  deleteDeficiency(deficiency: IFirmApplicationDeficiency) {    
    const dialogRef = this.dialog.open(ConfirmationDialogueComponent, {
      width: '400px',
      data: {message:'Are you sure you want to remove the application deficiency with ID: <strong>' + deficiency.id + '</strong>?',title:'Delete Application Deficiency'},});
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.firmService.deleteFirmApplicationDeficiency(deficiency.id).subscribe(result=>{
          this.updateFirmApplicationDeficiencies();
        },error=>{this.toastr.error("There was an error deleting the application deficiency: ", error)})
      }
    })
  }  

  updateFirmApplicationDeficiencies(){
    this.firmService.getFirmApplicationDeficiencies(this.data.application.id).subscribe(result=>{      
      this.applicationDeficiencies = result.sort((a, b) => {
        // Check if both items have the same IsResolved status
        if (a.isResolved === b.isResolved) {
          // If so, sort by id in descending order
          return b.id - a.id;
        } else {
          // If not, ensure items with IsResolved as false come first
          return a.isResolved ? 1 : -1;
        }
      });
      this.filterDeficiencyTable();
    },error=>{
      this.toastr.error("There was an error getting the application deficiencies: ", error);
    });
  }

  updateIndividualTable(){    
    this.individualTable = 
    {
      icon: 'staff',
      title:'Certified Individuals',
      layout:{
        columns:['personId', 'firstName','lastName'],
        container:[
          {displayName:'Id',columnName:'personId', type:'string', size: '10'},
          {displayName:'First Name',columnName:'firstName', type:'string', size: '40'},          
          {displayName:'Last Name',columnName:'lastName', type:'string', size: '43'},          
        ],
        data: []
      }
    };
  }

  assignApplicationPersonsToIData() {    
    const iData = [];
    this.applicationPersons.forEach((applicationPerson) => {      
      iData.push({
        id: applicationPerson.id,
        IDNumber: applicationPerson.certificateId,
        Name: applicationPerson.firstName + ' ' + applicationPerson.lastName,
        ActiveDisciplines: applicationPerson.discipline,
        Atp: applicationPerson.atp,
        TrainingDate: applicationPerson.trainingDate,
        FirmIsPaying: applicationPerson.firmIsPaying,
        ['Documents']: applicationPerson['Documents'] 
      })
    });
    return iData;
  }

  assignApplicationPerson() {    
    const iData = [];
    this.firmApplicationPerson.forEach((applicationPerson) => {      
      iData.push({
        Id: applicationPerson.person.id,        
        Name: applicationPerson.person.firstName + ' ' + applicationPerson.person.lastName,            
      })
    });    
    return iData;
  }

  onCoverFee(row: any){             
    let person = this.applicationPersons.filter(x=>x.id === row.id)[0]
    person.firmIsPaying = !row.FirmIsPaying;    
    person.applicationId = person.application.id;    
    this.firmService.saveFirmApplicationPerson(person).subscribe(result=>{},
      error=>{console.log("An error occurred while saving the individual:", error)});
  }

  saveApplication(): void {    
    this.firmApplication.userID = this.firmApplication.userID??this.userID;
    this.updateFirmApplicationData();  
    this.reload = this.firmApplication.id === 0; 
    this.firmService.saveFirmApplication(this.firmApplication).subscribe(
      result => {
        this.toastr.success("Application Saved");
        this.changeIndicator++;
        if(this.reload){
          this.firmApplication.id = result.id;
          this.updateFirmApplicationDeficiencies();          
        }
        this.firmApplication.firm = result.firm ?? this.firmApplication.firm;
        this.data.application = result;
        this.refreshLinkApprovalEmailStatus();
      },
      error => {
        this.toastr.error("Ther was an error saving the application: ",error);
      }
    )
  }

  exitApplication(){
    this.dialogRef.close(this.reload);    
  }
  
  setApplicationDataFormFields(){       
    this.applicationDataForm = new UntypedFormGroup({
      approvalDate: new UntypedFormControl(""),
      applicationDate: new UntypedFormControl("", [Validators.required]),
      applicationViableDate: new UntypedFormControl("", [Validators.required]),      
      firmName: new UntypedFormControl("", [Validators.required]),
      status: new UntypedFormControl(""),      
      applicationType: new UntypedFormControl(""),
      ccb: new UntypedFormControl(""),
      coverage: new UntypedFormControl(""),
      renewal: new UntypedFormControl({value: false, disabled: true}),
      previousApplication: new UntypedFormControl({value: "", disabled: this.data?.firmData?.renewal || this.data?.application?.renewal}),        
      isPublic: new UntypedFormControl(false), 
      inspections: new UntypedFormControl(false), 
      clearanceTesting: new UntypedFormControl(false), 
      leadHazardScreening: new UntypedFormControl(false), 
      riskAssessments: new UntypedFormControl(false), 
      abatement: new UntypedFormControl(false),
      mailingIsPhysical: new UntypedFormControl(false),
      contactTitle: new UntypedFormControl({value: "", disabled: this.isApplicationForExistingFirm }),
      contactFirstName: new UntypedFormControl({value: "", disabled: this.isApplicationForExistingFirm }, !this.isApplicationForExistingFirm ? [Validators.required] : []),
      contactMiddleName: new UntypedFormControl({value: "", disabled: this.isApplicationForExistingFirm }),
      contactLastName: new UntypedFormControl({value: "", disabled: this.isApplicationForExistingFirm }, !this.isApplicationForExistingFirm ? [Validators.required] : []),  
      contactPhone: new UntypedFormControl({value: "", disabled: this.isApplicationForExistingFirm }, !this.isApplicationForExistingFirm ? [Validators.required, Validators.pattern(/^\(?([0-9]{3})\)?[-\s]*([0-9]{3})-?([0-9]{4}).*$/)] : []),
      contactAlternatePhone: new UntypedFormControl({value: "", disabled: this.isApplicationForExistingFirm }, !this.isApplicationForExistingFirm ? [Validators.pattern(/^\(?([0-9]{3})\)?[-\s]*([0-9]{3})-?([0-9]{4}).*$/)] : []),
      contactFaxPhone: new UntypedFormControl({value: "", disabled: this.isApplicationForExistingFirm }, !this.isApplicationForExistingFirm ? [Validators.pattern(/^\(?([0-9]{3})\)?[-\s]*([0-9]{3})-?([0-9]{4}).*$/)] : []),
      contactEmail: new UntypedFormControl({value: "", disabled: this.isApplicationForExistingFirm }, !this.isApplicationForExistingFirm ? [Validators.required, Validators.email] : []),
      contactConfirmEmail: new UntypedFormControl({value: "", disabled: this.isApplicationForExistingFirm }, !this.isApplicationForExistingFirm ? [Validators.required, Validators.email] : []), 
      firmPhysicalState: new UntypedFormControl("", !this.isApplicationForExistingFirm ? [Validators.required] : []),
      firmPhysicalStreet: new UntypedFormControl("", !this.isApplicationForExistingFirm ? [Validators.required] : []),
      firmPhysicalCity: new UntypedFormControl("",!this.isApplicationForExistingFirm ? [Validators.required] : []),
      firmPhysicalZip: new UntypedFormControl("", !this.isApplicationForExistingFirm ? [Validators.required, Validators.pattern(/^\d{5}(-\d{4})?$/)] : []),
      firmPhysicalCounty: new UntypedFormControl(""),        
      firmMailingStreet: new UntypedFormControl("", !this.isApplicationForExistingFirm ? [Validators.required] : []),
      firmMailingCity: new UntypedFormControl("", !this.isApplicationForExistingFirm ? [Validators.required] : []),
      firmMailingState: new UntypedFormControl("", !this.isApplicationForExistingFirm ? [Validators.required] : []),
      firmMailingZip: new UntypedFormControl("", !this.isApplicationForExistingFirm ? [Validators.required,Validators.pattern(/^\d{5}(-\d{4})?$/)] : []),
      firmMailingCounty: new UntypedFormControl(""),
      firmPhone: new UntypedFormControl("", !this.isApplicationForExistingFirm ? [Validators.required, Validators.pattern(/^\(?([0-9]{3})\)?[-\s]*([0-9]{3})-?([0-9]{4}).*$/)] : []),
      firmAlternatePhone: new UntypedFormControl("", [Validators.pattern(/^\(?([0-9]{3})\)?[-\s]*([0-9]{3})-?([0-9]{4}).*$/)]),
      firmFaxPhone: new UntypedFormControl("", [Validators.pattern(/^\(?([0-9]{3})\)?[-\s]*([0-9]{3})-?([0-9]{4}).*$/)]),
      firmEmail: new UntypedFormControl("", !this.isApplicationForExistingFirm ? [Validators.required, Validators.email] : []),
      firmConfirmEmail: new UntypedFormControl("", !this.isApplicationForExistingFirm ? [Validators.required, Validators.email] : []),    
      firmWebsite: new UntypedFormControl(""),
      firmServices: new UntypedFormControl(""),
    }, {
      validators: [
        this.commonService.emailValidator('contactEmail', 'contactConfirmEmail'),
        this.commonService.emailValidator('firmEmail', 'firmConfirmEmail'), 
      ]
    }); 

    this.applicationAttestationForm = new UntypedFormGroup({
      attestation: new UntypedFormControl(false, [Validators.requiredTrue]),
      esignature: new UntypedFormControl("", [Validators.required])
    });    
  }

  requiredFieldValidator(fieldName: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const fieldValue = control.value[fieldName];
      const sameFieldValue = control.value.mailingIsPhysical;
      if (!sameFieldValue) {
        return (fieldValue !== null && fieldValue !== '' && fieldValue !== undefined) ? null : { [`${fieldName}Required`]: true };
      }
      return null;
    };
  }

  updateApplicationDeficiencyDebounceString(event: any){    
    this.applicationDeficiencyDebounceString.next(event.target.value);    
  }
  filterDeficiencyTable(){    
    this.filteredApplicationDeficiencies = this.applicationDeficiencies.filter(x=>
      (x.id + ' ' + x.description).toLowerCase().includes(this.applicationDeficiencyFilterString)
      && ((this.applicationDeficiencyStatusFilterString.value === "both") ? true : (x.isResolved.toString() === this.applicationDeficiencyStatusFilterString.value)) 
    );        
    this.updateDeficiencySource();  
  }

  updateDeficiencySource(){
    this.deficiencyDataSource = new MatTableDataSource<any>(this.filteredApplicationDeficiencies);
    this.deficiencyDataSource.sort = this.deficiencySort;
    this.deficiencyDataSource.paginator = this.deficiencyPaginator;
  }

  updateApplicationPersonDebounceString(event: any){        
    this.applicationPersonDebounceString.next(event.target.value);    
  }
  filterPersonTable(){        
    this.filteredApplicationPerson = this.firmApplicationPerson.filter(x => {      
      return x.person?.id?.toString().includes(this.applicationPersonFilterString) ||      
        x.person?.firstName?.toString().toLowerCase().includes(this.applicationPersonFilterString.toLowerCase()) ||
        x.person?.lastName?.toString().toLowerCase().includes(this.applicationPersonFilterString.toLowerCase())
      }).map(x=>{
      const {id: personId, ...person} = x.person;      
      return {...x, ...person, personId};
    });   
    this.updatePersonSource();  
  }

  updatePersonSource(){
    this.personDataSource = new MatTableDataSource<any>(this.filteredApplicationPerson);
    this.personDataSource.sort = this.personSort;
    this.personDataSource.paginator = this.personPaginator;
  }

  updateFirmApplicationData(): void {    
    for (const controlName in this.firmApplication) {
      if (this.applicationDataForm.controls.hasOwnProperty(controlName)) {
        this.firmApplication[controlName] = this.applicationDataForm.controls[controlName].value;        
      } else if (this.applicationAttestationForm.controls.hasOwnProperty(controlName)) {
        this.firmApplication[controlName] = this.applicationAttestationForm.controls[controlName].value;
      }
    } 
    if(this.data?.firmData?.firm !== undefined)
    {
      this.firmApplication.firm = this.data.firmData.firm;
    } else if (this.getLinkedFirm() !== null) {
      this.firmApplication.firm = this.getLinkedFirm();
    }
  }

  onApplicationTypeChange(event: any) {        
    this.updateFirmApplicationData();
    this.updateIndividualTable();    
  }

  loadFormFields(){
    for (const controlName in this.firmApplication) {
      if (this.applicationDataForm.controls.hasOwnProperty(controlName)) {        
        this.applicationDataForm.controls[controlName].setValue(this.firmApplication[controlName]);  
        if(!this.canEdit)
          this.applicationDataForm.controls[controlName].disable();
      } else if (this.applicationAttestationForm.controls.hasOwnProperty(controlName)) {
        this.applicationAttestationForm.controls[controlName].setValue(this.firmApplication[controlName]);
        if(!this.canEdit)
          this.applicationAttestationForm.controls[controlName].disable();
      }
    }

    this.mailingIsSame();    
  }
  
  deleteIndividual(row: any){             
    let name = row.person.firstName + " " + row.person.lastName;

    const dialogRef = this.dialog.open(ConfirmationDialogueComponent, {
      width: '400px',
      data: {message:'Are you sure you want to remove the staff member: <strong>' + name + '</strong>?',title:'Delete Application Staff Member'},});
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.firmService.deleteFirmPerson(row.id).subscribe(res=>{      
          this.updateFirmApplicationPeople();
        },err=>{this.toastr.error("An error occurred when deleting the application staff member: ", err)});
      }
    })
  }

  editIndividual(event: MouseEvent, individual: IFirmPerson) {         
    const dialogRef = this.dialog.open(AddFirmApplicationPersonComponent, {        
      data: {firmApplication: this.firmApplication, person: individual, firmPeople: this.firmApplicationPerson},
      width: this.isMobile ? '90%' : '30%',
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(result => {    
      if (result){    
        this.updateFirmApplicationPeople();            
      }    
    });    
  }

  updateFirmApplicationPeople():void {
    this.firmService.getFirmApplicationPeople(this.data.application.id).subscribe(res=>{      
      this.firmApplicationPerson = res.sort((a, b) => a.person.firstName.localeCompare(b.person.firstName));          
      this.filterPersonTable();
    },err=>{this.toastr.error("An error occurred getting the Firm Application People: ", err)});
  }

  mailingIsSame(): void {    
    if(!this.requiresManualFirmDetails()){
      this.applicationDataForm.get('firmMailingStreet').clearValidators();
      this.applicationDataForm.get('firmMailingCity').clearValidators();
      this.applicationDataForm.get('firmMailingState').clearValidators();
      this.applicationDataForm.get('firmMailingZip').clearValidators();
    }
    else if(this.applicationDataForm.get('mailingIsPhysical').value){
      this.applicationDataForm.get('firmMailingStreet').clearValidators();
      this.applicationDataForm.get('firmMailingCity').clearValidators();
      this.applicationDataForm.get('firmMailingState').clearValidators();
      this.applicationDataForm.get('firmMailingZip').clearValidators();
    }
    else{
      this.applicationDataForm.get('firmMailingStreet').setValidators([Validators.required]);
      this.applicationDataForm.get('firmMailingCity').setValidators([Validators.required]);
      this.applicationDataForm.get('firmMailingState').setValidators([Validators.required]);
      this.applicationDataForm.get('firmMailingZip').setValidators([Validators.required]);
    }

    this.applicationDataForm.get('firmMailingStreet').updateValueAndValidity();
    this.applicationDataForm.get('firmMailingCity').updateValueAndValidity();
    this.applicationDataForm.get('firmMailingState').updateValueAndValidity();
    this.applicationDataForm.get('firmMailingZip').updateValueAndValidity();
  }

  approveFirm(){
    if (this.isLinkApplication) {
      this.approveLinkApplication();
      return;
    }

    const dialogRef = this.dialog.open(ConfirmationDialogueWithFieldComponent, {
      width: '400px',
      autoFocus: false,
      data: {
        message:'Are you sure you want to <strong>approve</strong> this application?',
        title:'Approve Application',
        type:'firm', 
        controlNumber: this.firmApplication.previousApplication, 
        selectedDate: this.applicationDataForm.controls.applicationViableDate.value,
        codeType: this.firmApplication.applicationType === 'rrp' ? CODE_TYPES.rrpFirm : CODE_TYPES.lbpFirm
      },});
    dialogRef.afterClosed().subscribe(result => {
      if(result !== false && result !== undefined && result !== null){ 
        this.applicationDataForm.controls.previousApplication.setValue(result.controlNumber);
        this.issueDate = result.issueDate;
        this.certificateNumber = result.certificateNumber;

        this.updateFirmApplicationData();            
        if(this.firmApplication.approvalDate === null || this.firmApplication.approvalDate === undefined || this.firmApplication.approvalDate === "" || isNaN(new Date(this.firmApplication.approvalDate).getTime())){
          this.firmApplication.approvalDate = new Date().toISOString();
        }
        
        const firm: IFirm = {
          id: this.data?.firmData?.firm?.id ?? 0,
          inactive: this.data?.firmData?.firm?.inactive ?? false,
          isPrivate: this.firmApplication.isPublic,
          name: this.firmApplication.firmName,
          servicesAvailable: this.firmApplication.firmServices,
          ccbExpirationDate: null,
          ccb: this.firmApplication.ccb,
          coverage: this.firmApplication.coverage,
          certificationNumber: null,
          certificates: null
        };
        
        this.firmService.saveFirm(firm).subscribe(
          res=>{
            this.toastr.success("Firm Application Approved");              
            this.saveFirmApprovalData(res);
          },
          err=>{this.toastr.error("An error occurred saving the firm: ", err)},
        )        
      }
    })
  }

  private approveLinkApplication(): void {
    const linkedFirm = this.getLinkedFirm();

    this.linkValidationSummaryRequested = true;
    this.linkUserDisplayControl.markAsTouched();
    this.linkFirmIdDisplayControl.markAsTouched();
    this.applicationDataForm.get('firmName')?.markAsTouched();
    this.applicationAttestationForm.get('attestation')?.markAsTouched();
    this.applicationAttestationForm.get('esignature')?.markAsTouched();

    const validationErrors = this.getLinkValidationErrors();
    if (validationErrors.length > 0) {
      this.step = this.getFirstLinkErrorStepIndex(validationErrors);
      this.scrollLinkDeficiencyCardIntoView();
      this.toastr.error(
        `Please complete all required fields. ${validationErrors.length} field(s) need attention.`,
        'Form Validation Error',
        { timeOut: 5000 }
      );
      return;
    }

    if (!linkedFirm?.id) {
      this.toastr.error('Link applications must be associated with an existing firm before approval.');
      return;
    }

    const today = new Date().toISOString().split('T')[0];
    const applicationDate = this.getApprovalDialogDateValue(this.applicationDataForm.get('applicationDate')?.value || this.firmApplication.applicationDate) || today;
    const applicationViableDate = this.getApprovalDialogDateValue(this.applicationDataForm.get('applicationViableDate')?.value || this.firmApplication.applicationViableDate) || applicationDate;
    const approvalDate = this.getApprovalDialogDateValue(this.applicationDataForm.get('approvalDate')?.value || this.firmApplication.approvalDate) || today;

    const dialogRef = this.dialog.open(AtpApplicationApprovalDialogComponent, {
      width: '500px',
      autoFocus: false,
      data: {
        title: 'Approve Link Request?',
        submissionType: 'link',
        applicationDate,
        applicationViableDate,
        approvalDate,
        atpOrId: ''
      },
    });

    dialogRef.afterClosed().subscribe((result: false | AtpApplicationApprovalDialogResult) => {
      if (!(result && result.confirmed)) {
        return;
      }

      this.applicationDataForm.patchValue({
        applicationDate: result.applicationDate,
        applicationViableDate: result.applicationViableDate,
        approvalDate: result.approvalDate
      });

      this.updateFirmApplicationData();
      this.firmApplication.applicationDate = this.toApprovalIsoString(result.applicationDate) || new Date().toISOString();
      this.firmApplication.applicationViableDate = this.toApprovalIsoString(result.applicationViableDate) || this.firmApplication.applicationDate;
      this.firmApplication.approvalDate = this.toApprovalIsoString(result.approvalDate) || new Date().toISOString();
      this.firmApplication.approverEmail = this.userID;
      this.firmApplication.status = APPLICATION_STATUS.approved;
      this.firmApplication.firm = linkedFirm;

      this.firmService.approveFirmLinkApplication(this.firmApplication).subscribe(
        res=>{
          this.firmApplication = res;
          this.data.application = res;
          this.canEdit = false;
          this.toastr.success("Firm Link Application Approved");
          this.loadFormFields();
          this.dialogRef.close(true);
        },
        err=>{this.toastr.error("There was an error approving the firm link application: ", err)}
      )
    });
  }

  private getApprovalDialogDateValue(value: any): string {
    if (!value) {
      return '';
    }

    const parsedDate = value instanceof Date ? value : new Date(value);
    return isNaN(parsedDate.getTime()) ? '' : parsedDate.toISOString().split('T')[0];
  }

  private toApprovalIsoString(value: string | null | undefined): string | null {
    if (!value) {
      return null;
    }

    const parsedDate = new Date(value);
    return isNaN(parsedDate.getTime()) ? null : parsedDate.toISOString();
  }

  saveFirmApprovalData(savedFirm: IFirm){
    const currentDate = new Date(this.issueDate);
    const expirationDate = new Date(currentDate);
    expirationDate.setFullYear(currentDate.getFullYear() + (this.firmApplication.applicationType === 'rrp' ? 5 : 3));
    this.data.application.approverEmail = this.userID;    
    this.data.application.status = APPLICATION_STATUS.approved;
    this.data.application.firm = savedFirm;
    this.data.application.applicationViableDate = this.firmApplication.applicationViableDate;
    
    const firmCertificate: IFirmCertificate = {
      id: 0,
      codeType: (this.firmApplication.applicationType === 'rrp') ? CODE_TYPES.rrpFirm : CODE_TYPES.lbpFirm,
      controlNumber: this.data?.firmData?.firmCertificateForRenewal?.controlNumber ?? this.applicationDataForm.controls.previousApplication.value,
      certificateNumber: this.certificateNumber,
      stage: this.data.application.renewal ? CERTIFICATE_STAGE_TYPES.recert : CERTIFICATE_STAGE_TYPES.initial,
      issueDate: currentDate.toISOString(),
      expirationDate: expirationDate.toISOString(),
      firm: savedFirm,
      application: this.firmApplication,
      dateOfLetter: null,
    };
    const newAddressPhysical: IAddress = {
      id: this.data?.firmData?.physicalAddress?.id ?? 0,
      city: this.firmApplication.firmPhysicalCity,
      contactType: 'Physical',            
      county: this.firmApplication.firmPhysicalCounty,
      state: this.firmApplication.firmPhysicalState,
      street: this.firmApplication.firmPhysicalStreet,
      zip: this.firmApplication.firmPhysicalZip,
    };
    const firmAddressPhysical: IFirmAddress = {
      id: 0,
      firm: savedFirm,
      address: newAddressPhysical,
      isCurrentPhysical: true,      
      isCurrentMailing: false,      
    };
    const newAddressMailing: IAddress = {
      id: this.data?.firmData?.mailingAddress?.id ?? 0,
      city: (this.firmApplication.mailingIsPhysical ? this.firmApplication.firmPhysicalCity : this.firmApplication.firmMailingCity),
      contactType: 'Mailing',            
      county: this.firmApplication.mailingIsPhysical ? this.firmApplication.firmPhysicalCounty : this.firmApplication.firmMailingCounty,
      state: this.firmApplication.mailingIsPhysical ? this.firmApplication.firmPhysicalState : this.firmApplication.firmMailingState,
      street: this.firmApplication.mailingIsPhysical ? this.firmApplication.firmPhysicalStreet : this.firmApplication.firmMailingStreet,
      zip: this.firmApplication.mailingIsPhysical ? this.firmApplication.firmPhysicalZip : this.firmApplication.firmMailingZip,
    };
    const firmAddressMailing: IFirmAddress = {
      id: 0,
      firm: savedFirm,
      address: newAddressMailing,
      isCurrentPhysical: false,      
      isCurrentMailing: true,      
    };
    const accountAffiliation: IAccountAffiliation = {
      id: 0,
      userID: this.data.application.userID,
      firm: savedFirm,
      atp: null,
      status: 'Active',
      requestedStatus: 'Active',
      lastUpdatedBy: null,
      userName: null,
      person: null,
    };
    const contactInformationForFirm: IContactInformation = {
      id: this.data?.firmData?.contactInformation?.id ?? 0,
      contactType: 'Work',
      phone: this.firmApplication.firmPhone,
      cell: this.firmApplication.firmAlternatePhone,
      fax: this.firmApplication.firmFaxPhone,
      ext: '',
      email: this.firmApplication.firmConfirmEmail,
      website: this.firmApplication.firmWebsite,
      label: ''
    };
    const firmContactInformation: IFirmContactInformation = {
      id: 0,
      firm: savedFirm,
      contactInformation: contactInformationForFirm,
    };
    const personForFirmAndContact: IPerson = {
      id: 0,
      title: this.firmApplication.contactTitle,
      firstName: this.firmApplication.contactFirstName,
      middleName: this.firmApplication.contactMiddleName,
      lastName: this.firmApplication.contactLastName,
      ssn: '',
      dateOfBirth: null,
      response: '',
      inactive: false,
      certificates: null
    }
    const contactInformationForPerson: IContactInformation = {
      id: 0,
      contactType: 'Work',
      phone: this.firmApplication.contactPhone,
      cell: this.firmApplication.contactAlternatePhone,
      fax: this.firmApplication.contactFaxPhone,
      ext: '',
      email: this.firmApplication.contactConfirmEmail,
      website: '',
      label: ''
    };
    const personContactInformation: IPersonContactInformation = {
      id: 0,
      person: personForFirmAndContact,
      contactInformation: contactInformationForPerson,
    };
    const firmPerson: IFirmPerson = {
      id: 0,
      firm: savedFirm,
      person: personForFirmAndContact,
      application: null,      
      isPOC: true,
    };

    let credentialsToAdd:IFirmLeadCredential[] = []              
    let credentialsToDelete:IFirmLeadCredential[] = []
    for(const key in FIRM_SERVICES) {       
      if(this.firmApplication[key] && (!this.data?.firmData?.firmCurrentCredentials?.some(x=>x.firmLeadCredentialType === FIRM_SERVICES[key]))){         
        credentialsToAdd.push({
          id: 0,
          firm: savedFirm,
          firmLeadCredentialType: FIRM_SERVICES[key],
        });        
      }
      else if(this.data?.firmData?.firmCurrentCredentials?.some(x=>x.firmLeadCredentialType === FIRM_SERVICES[key]) ?? true){        
        credentialsToDelete.push(this.data?.firmData?.firmCurrentCredentials?.filter(x=>x.firmLeadCredentialType === FIRM_SERVICES[key])[0]);        
      }            
    }    

    const existingApplicationPersonIds = Array.from(new Set(
      (this.firmApplicationPerson || [])
        .map((applicationStaffMember) => applicationStaffMember?.person?.id || 0)
        .filter((personId) => personId > 0)
    ));

    const requestStaffAffiliationApprovals = (personIds: number[]): void => {
      personIds.forEach((personId) => {
        this.firmService.requestFirmStaffAffiliation(savedFirm.id, personId).subscribe({
          next: () => undefined,
          error: (err) => {
            this.toastr.error("There was an error requesting staff affiliation approval: ", err);
          }
        });
      });
    };

    (this.firmApplicationPerson || []).forEach((applicationStaffMember) => {
      applicationStaffMember.firm = savedFirm;

      // Existing people should move through affiliation approval email flow.
      if ((applicationStaffMember?.person?.id || 0) > 0) {
        return;
      }

      this.firmService.saveFirmPerson(applicationStaffMember).subscribe({
        next: () => undefined,
        error: (err) => {
          this.toastr.error("An error occurred saving the firm person: ", err);
        }
      });
    });

    if (existingApplicationPersonIds.length > 0) {
      this.firmService.getFirmPeople(savedFirm.id).subscribe({
        next: (existingFirmPeople) => {
          const existingFirmPersonIds = new Set(
            (existingFirmPeople || [])
              .map((firmPerson) => firmPerson?.person?.id || 0)
              .filter((personId) => personId > 0)
          );

          const personIdsToRequest = existingApplicationPersonIds
            .filter((personId) => !existingFirmPersonIds.has(personId));

          requestStaffAffiliationApprovals(personIdsToRequest);
        },
        error: () => {
          requestStaffAffiliationApprovals(existingApplicationPersonIds);
        }
      });
    }

    if(!this.isApplicationForExistingFirm)
    {
      this.personService.savePerson(personForFirmAndContact).subscribe(personResult=>{
        firmPerson.person = personResult;
        this.firmService.saveFirmPerson(firmPerson).subscribe(
          res=>{
            personContactInformation.person = res.person;
            this.personService.savePersonContactInfo(personContactInformation).subscribe(
              res=>{},
              err=>{this.toastr.error("There was an error saving the person contact information: ", err)}
            )
          },
          err=>{this.toastr.error("There was an error saving the firm person: ", err)}
        )          
      },err=>{})
  
      this.firmService.saveFirmContactInformation(firmContactInformation).subscribe(
        res=>{},
        err=>{this.toastr.error("There was an error saving the firm contact information: ", err)}
      )
  
      // Only create account affiliation if userID exists (i.e., application is from a public user, not staff)
      if (this.data.application.userID) {
        this.commonService.saveAccountAffiliation(accountAffiliation).subscribe(
          res=>{},
          err=>{this.toastr.error("There was an error saving the account affiliation: ", err)}
        )
      }                

      this.commonService.saveAddress(newAddressPhysical).subscribe(
        res=>{            
          firmAddressPhysical.address = res;
          this.firmService.saveFirmAddress(firmAddressPhysical).subscribe(   
            res=>{},         
            err=>{this.toastr.error("There was an error saving the firm address: ", err)}
          );
        },
        err=>{this.toastr.error("An error occurred saving the physical address: ", err)}
      )   
  
      this.commonService.saveAddress(newAddressMailing).subscribe(
        res=>{            
          firmAddressMailing.address = res;
          this.firmService.saveFirmAddress(firmAddressMailing).subscribe(
            res=>{},
            err=>{this.toastr.error("There was an error saving the firm address: ", err)}
          );
        },
        err=>{this.toastr.error("An error occurred saving the mailing address: ", err)}
      )
    }

    this.firmService.saveFirmApplication(this.data.application).subscribe(
      res=>{},
      err=>{this.toastr.error("There was an error saving the firm license: ", err)}
    );

    this.firmService.saveFirmCertificate(firmCertificate).subscribe(
      res=>{this.dialogRef.close(true);},
      err=>{this.toastr.error("There was an error saving the firm certificate: " + err.error)}
    );

    credentialsToAdd?.forEach(credentialToAdd=>{
      this.firmService.saveFirmLeadCredential(credentialToAdd).subscribe(res=>{},err=>{
        this.toastr.error("There was an error saving the firm credential: ", err)
      })
    })

    credentialsToDelete?.forEach(credentialToDelete=>{
      if(credentialToDelete !== undefined){
        this.firmService.deleteFirmLeadCredential(credentialToDelete.id).subscribe(res=>{},err=>{
          this.toastr.error("There was an error deleting the firm credential: ", err)
        })
      }
    })
  }

  displayLimit(text: any, limit: string){
    let newText = text;
    if (typeof text === 'string' && text.length > parseInt(limit)){
      newText = newText.substring(0, limit) + "...";
    }    
    return newText;
  }

  refreshTableApplicationDocuments(){
    this.documentService.getDocuments({ ownerType: 'FirmApplication', ownerId: this.firmApplication.id }).subscribe(result=>{
      this.tableApplicationDocumentsData = result.sort((a, b) => a.fileName.localeCompare(b.fileName));
      this.filterDocumentTable();
    },error=>{
      this.toastr.error("There was an error getting the documents: ", error);
    })
  }

  editDocument(row: any){
    const dialogRef = this.dialog.open(AddDocumentComponent, {
      width: this.isMobile ? '90%' : '30%',
      data: {document: row, entity: 'firm', entityRef: this.firmApplication},
      autoFocus: false,});
    dialogRef.afterClosed().subscribe(result => {      
        this.refreshTableApplicationDocuments();      
    });
  }    

  async downloadFile(row: any) {    
    this.documentService.downloadDocument(row).subscribe({
      error: () => this.toastr.error("An error occurred while downloading the document.")
    });
  }  

  clearFile(row: any) {      
    const dialogRef = this.dialog.open(ConfirmationDialogueComponent, {
      width: '400px',      
      data: {message: 'Are you sure you want to <strong>Delete</strong> this Application Document?',title: 'Delete the Application Dcoument'},});
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.documentService.deleteDocument(row.id).subscribe(result=>{
          this.refreshTableApplicationDocuments();
        },
        error=>{
          this.toastr.error("An error occurred while deleting the document: ", error);
        });                 
      }
    })
  }

  filterDocumentTable(): void {
    this.tableApplicationDocumentsFilteredData = this.tableApplicationDocumentsData;
    
    this.tableApplicationDocumentsFilteredData = this.tableApplicationDocumentsFilteredData.filter(x => {      
      return x.id?.toString().includes(this.filterDocumentString) ||      
        x.fileName?.toString().toLowerCase().includes(this.filterDocumentString.toLowerCase()) ||
        x.fileDescription?.toString().toLowerCase().includes(this.filterDocumentString.toLowerCase())        
    });

    this.updateDocumentDataSource();
  }
  updateDocumentDataSource(){    
    this.documentDataSource = new MatTableDataSource<any>(this.tableApplicationDocumentsFilteredData);
    this.documentDataSource.paginator = this.documentPaginator;
    this.documentDataSource.sort = this.documentSort;    
  }
  
  paymentUpdated(payments: IPayment[]) {
   
  }
}
